// extracted by mini-css-extract-plugin
export default {"gamesNavWrap":"styles_gamesNavWrap__tT++l","gamesNavItemWrap":"styles_gamesNavItemWrap__340q-","gamesNavSearchWrap":"styles_gamesNavSearchWrap__ODz7+"};